import { axiosClient } from '../core';

export const profileApi = {
    getProfile: () => axiosClient.get('/profile'),
    updateProfile: (data: any) => axiosClient.put('/profile', data),
    updateAvatar: (formData: FormData) => axiosClient.patch('/profile/avatar', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    }),
    deleteAvatar: () => axiosClient.delete('/profile/avatar'),

    getOrders: (params?: { page?: number; pageSize?: number }) => axiosClient.get('/profile/orders', { params }),

    getAddresses: () => axiosClient.get('/profile/addresses'),
    createAddress: (data: any) => axiosClient.post('/profile/addresses', data),
    updateAddress: (id: string, data: any) => axiosClient.put(`/profile/addresses/${id}`, data),
    deleteAddress: (id: string) => axiosClient.delete(`/profile/addresses/${id}`),
    setDefaultAddress: (id: string) => axiosClient.patch(`/profile/addresses/${id}/default`),

    trackOrder: (orderId: string) => axiosClient.get(`/profile/orders/${orderId}/track`),
};
